var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewsRenderer',{key:_vm.newsUid,attrs:{"is-news-opened-using-a-direct-link":true},on:{"onNewsClosed":_vm.onNewsClosed}})}
var staticRenderFns = []

export { render, staticRenderFns }